import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";

interface MovieCardProps {
  movie: Movie;
}

export default function MovieCard({ movie }: MovieCardProps) {
  return (
    <Link
      to={`/movie/${movie.id}`}
      data-product-shop
      className="group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-accent-300"
    >
      <div className="relative w-full overflow-hidden bg-secondary-200" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={movie.cover}
          alt={`${movie.title} 海报`}
          title={`${movie.title} - 黄色在线影视资源`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute right-2 top-2 inline-flex items-center gap-0.5 rounded-md bg-primary-950/85 px-2 py-0.5 font-heading text-xs font-bold text-accent-300">
          <i className="ri-star-fill text-[10px]" aria-hidden="true" />
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-primary-950/90 to-transparent px-2 pb-2 pt-6 text-xs font-medium text-background-50">
          {movie.status}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate font-heading text-sm font-bold text-foreground-950 transition-colors group-hover:text-accent-600">
          {movie.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {movie.year} · {movie.region}
        </p>
        <p className="mt-1.5 truncate text-xs text-foreground-400">
          {movie.genres.slice(0, 2).join(" / ")}
        </p>
      </div>
    </Link>
  );
}